import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorModel, EventService, OccEndpointsService } from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { BehaviorSubject, Observable } from 'rxjs';
export interface AddressValidation {
  decision?: string;
  // TODO: Simplify with converter
  errors?: { errors: ErrorModel[] };
}

@Injectable({ providedIn: 'root' })
export class ProductService {
  pdpDetails = new BehaviorSubject<any>(null);
  productCode = new BehaviorSubject<any>(null);
  constructor(
    private httpClient: HttpClient,
    private occService: OccEndpointsService,
    private userAccount: UserAccountFacade,
    protected eventService: EventService
  ) {}

  getProductsDetails(productCode: string): Observable<any> {
    const fetchUrl = this.occService.buildUrl(
      `/products/${productCode}?fields=DEFAULT`
    );
    return this.httpClient.get<any>(fetchUrl);
  }

  getProductsSearchResult(): Observable<any> {
    const fetchUrl = this.occService.buildUrl(
      `/products/search?fields=products(code,name,summary,configurable,configuratorType,multidimensional,price(FULL),images(DEFAULT),stock(FULL),averageRating,variantOptions),facets,breadcrumbs,pagination(DEFAULT),sorts(DEFAULT),freeTextSearch,currentQuery`
    );
    return this.httpClient.get<any>(fetchUrl);
  }

  getWishlistResults(userId: any): Observable<any> {
    const fetchUrl = this.occService.buildUrl(
      `/users/${userId}/wishlist/get?fields=DEFAULT`
    );
    return this.httpClient.get<any>(fetchUrl);
  }

  removeWishlistEntry(userId: any, productId: any): Observable<any> {
    const fetchUrl = this.occService.buildUrl(
      `/users/${userId}/wishlist/remove?fields=DEFAULT&productId=${productId}`
    );
    return this.httpClient.post<any>(fetchUrl, {});
  }

  addWishlistEntry(userId: any, productId: any): Observable<any> {
    const fetchUrl = this.occService.buildUrl(
      `/users/${userId}/wishlist/add?fields=DEFAULT&productId=${productId}`
    );
    return this.httpClient.post<any>(fetchUrl, {});
  }
}
